<template>
  <layout-default-appbar>
    Home
  </layout-default-appbar>
</template>

<script>
import LayoutDefaultAppbar from '@/layouts/default/AppBar.vue';

export default {
  name: 'ViewHomeAppBar',

  components: {
    LayoutDefaultAppbar,
  },
};
</script>
